import { TrackEventDescriptionPaymentT, TrackPageActionPaymentT } from '@consumer-frontend/nc-utils';

import { TrackingEndpointsT, useTrackingBase } from './useTrackingBase';
import { apiEndpoints, dashboardFetchers as fetchers } from '../../lib';

/**
 * Provides Dashboard app tracking triggers.
 *
 * @param accountId {string} Account ID used for tracking endpoint params
 * @returns Page and event tracking triggers and errors
 */
export const useTrackingDashboard = (accountId: string) => {
  const endpoints: TrackingEndpointsT = {
    trackEventUrl: apiEndpoints.dashboard.trackEvent(accountId),
    trackPageUrl: apiEndpoints.dashboard.trackPage(accountId),
  };

  return useTrackingBase<TrackPageActionPaymentT, TrackEventDescriptionPaymentT>({
    endpoints,
    fetchers,
  });
};
